<template> 
  <SubAdminTop /> 
</template> 

<script> 
  import SubAdminTop from '../components/SubAdminTop' 
  export default { 
    components: { 
      SubAdminTop 
    } 
  } 
</script> 